export const replaceStringParameters = (
  template: string,
  parameters: Record<string, string>,
  paramKeyToTemplateParam: (key: string) => string = (key) => '${' + key + '}'
) => {
  let result = template;
  for (const key in parameters) {
    if (parameters[key]) {
      const templateParam = paramKeyToTemplateParam(key);
      const escapedTemplateParam = templateParam.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const regex = new RegExp(escapedTemplateParam, 'g');
      result = result.replace(regex, parameters[key]);
    }
  }
  return result;
};

export const capitalize = (s: string) => {
  if (!s) return '';
  s = s.toLowerCase();
  return s.charAt(0).toUpperCase() + s.slice(1);
};
